import styled from 'styled-components';

import { Dropdown, Input } from '@gympass/yoga';
import { wellzTheme } from '@wellz-theme/mui';

export const TimeContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${wellzTheme.spacing(2)};
`;

export const TimeDropdown = styled(Dropdown).attrs({ label: '00:00' })`
  *,
  *::after,
  *::before {
    color: ${({ theme }) => theme.yoga.colors.deep} !important;
  }

  > div {
    border-color: ${({ theme }) => theme.yoga.colors.tableBorder};
  }

  svg {
    fill: ${({ theme }) => theme.yoga.colors.deep};
  }
  width: 100%;
`;

export const DateInput = styled(Input).attrs({
  placeholder: 'DD/MM/YYYY',
  maxLength: 10,
  label: '',
  hideMaxLength: true,
})`
  width: 100%;
`;
